import type { JSX } from 'react';
import { Button } from '@/components/ui/button';

interface AddReferenceContactActionProps {
  hasContacts: boolean;
  onClick: () => void;
}

export function AddReferenceContactAction({
  hasContacts,
  onClick,
}: AddReferenceContactActionProps): JSX.Element {
  return (
    <div className={hasContacts ? 'border-t pt-3' : undefined}>
      <Button
        variant="outline"
        size="sm"
        className="h-auto w-full whitespace-normal py-1.5 sm:w-auto"
        onClick={onClick}
      >
        {hasContacts ? 'Add another reference contact' : 'Add reference contact'}
      </Button>
    </div>
  );
}
